import YxTable from './yx-table.vue';

export default {
  install(application) {
    application.component('yx-table', YxTable);
  },
};
